module.exports = __webpack_public_path__ + "images/hasten_icon.08515332653935623dde4c5a26f58e65.png";